// Utility to get selected branch ID from localStorage
export const getSelectedBranchId = () => {
  return localStorage.getItem('selected_branch_id') || null;
};

export const clearSelectedBranch = () => {
  localStorage.removeItem('selected_branch_id');
};

// The branch and academic session picked in the header belong to one institute's login: another
// login in the same browser (sign-in, impersonation, institute switch) starts from its own.
const ACADEMIC_SCOPE_KEYS = [
  'selected_branch_id',
  'selected_academic_session_id',
  'active_academic_session_id',
  'active_academic_session_name',
];

export const clearAcademicScope = () => {
  try {
    ACADEMIC_SCOPE_KEYS.forEach(key => localStorage.removeItem(key));
  } catch {}
};
